import { TAG_SORT_ALPHABETICAL } from "@/utils/tags";

export class ClientConfig {
  constructor(config, id) {
    this.id = id;
    if (!config) {
      this.intake = {};
      this.priorAuth = {};
      this.submissionMethod = null;
      this.key = null;
      this.tagSortOrder = TAG_SORT_ALPHABETICAL;
      return;
    }
    this.intake = { ...config.uiConfig.intake };
    this.priorAuth = { ...config.uiConfig.priorAuth };
    this.submissionMethod = config.uiConfig?.submissionMethod;
    this.key = config.uiConfig.key;
    this.defaultPostLoginPage = config.uiConfig?.defaultPostLoginPage || "all-submissions";
    this.kanbanViewEnabled = config.uiConfig?.kanbanViewEnabled ?? true;
    this.isAdminCompany = config.isAdminCompany ?? false;
    this.salesDemoLauncherEnabled = config.uiConfig?.salesDemoLauncherEnabled ?? false;
    this.tagSortOrder = config.uiConfig?.tagSortOrder || TAG_SORT_ALPHABETICAL;
  }
}
